import { render } from "./PretensionId.vue?vue&type=template&id=0892dd31&scoped=true&ts=true"
import script from "./PretensionId.vue?vue&type=script&lang=ts"
export * from "./PretensionId.vue?vue&type=script&lang=ts"

import "./PretensionId.vue?vue&type=style&index=0&id=0892dd31&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0892dd31"]])

export default __exports__